import {RedeemManager} from "@/Core/Redeem/RedeemManager";
import TrackBase from "@/Core/Track/TrackBase";

export default class TrackRedeem extends TrackBase {

    /**
     * 点击兑换页时（redeem）
     * @param from 来源标识：1=大厅点击，2=游戏界面点击，3=首次满足提现界面点击
     */
    static async redeem_click(from: number) {
        const {availableScAmount} = await this.userInfo();
        // let key1 = availableScAmount >= RedeemManager.Instance.getMinimumScRedeem ? 1 : 0;
        // let key2 = '';//TODO 看看这个逻辑还要不要
        //
        // this.T512("redeem_click", key1.toString(), key2, [
        //     ["from", from.toString()]
        // ]);
    }

    /** 兑换页展示时 */
    static redeem_show() {
        this.T512("redeem_show");
    }

    /** 兑换账号输入弹窗展示时 */
    static redeem_account_show() {
        this.T512("redeem_account_show");
    }

    /**
     * 兑换账号输入弹窗展示时
     * @param reason 失败原因：1=网络返回错误，2=账号格式错误，3=密码格式错误，4=zipcode填写错误，5=未选择州/省，6=未填写城市，7=国家错误
     * @param zipcode 用户填写的邮政编码
     */
    static async redeem_account_fail_show(reason: number, zipcode: string) {
        const {userId,zipCode} = await this.userInfo();
        this.T512("redeem_account_fail_show", reason.toString(), undefined, [
            ["zipcode", zipcode ?? zipCode]
            , ["user_id", userId.toString()]
            , ["phone_number", ""]//TODO
        ]);
    }

    /**
     * 成功输入账号时（不成功不统计）
     * @param channel 渠道标识
     */
    static redeem_account_click(channel: number) {
        this.T512("redeem_account_click", ``+channel);
    }

    /** 兑换金额输入弹窗展示时 */
    static redeem_amount_show() {
        this.T512("redeem_amount_show");
    }

    /**
     * 成功兑换时（不成功不统计）
     * @param money 兑换金额
     */
    static redeem_amount_click(money: string) {
        this.T512("redeem_amount_click", money);
    }

    /** 兑换已提交弹窗展示时 */
    static redeem_submit_show() {
        this.T512("redeem_submit_show");
    }

    /** 手续费弹窗展示时 */
    static redeem_fee_show() {
        this.T512("redeem_fee_show");
    }

    /** 兑换记录弹窗展示时 */
    static redeem_record_show() {
        this.T512("redeem_record_show");
    }

    /** 兑换成功弹窗展示时 */
    static redeem_success_show() {
        this.T512("redeem_success_show");
    }

    /** 兑换失败弹窗展示时 */
    static redeem_fail_show() {
        this.T512("redeem_fail_show");
    }

    /** 兑换失败弹窗展示时 */
    static redeem_review_show() {
        this.T512("redeem_review_show");
    }

    /**
     * 点击兑换审核中弹窗的确定按钮
     * @param from 来源标识：1=从兑换页的cancel按钮进来，2=从兑换记录的cancel按钮进来
     */
    static redeem_review_click(from: number) {
        this.T512("redeem_review_click", from.toString());
    }
}
